<!--
  Widget shell: the "Give feedback" launcher (FAB) and the slide-out panel.
  Header is scaffolded (no behaviour yet); the panel body is still blank.
-->

<!-- Opts the @brafton/feedback-components inside the widget into their premium finish.
     `display: contents` keeps it out of layout. -->
<div class="fb-premium">

<!-- Floating launcher -->
<button
  class="fab"
  [class.is-hidden]="panelOpen() || placing() || captureModalOpen() || newFeedbackOpen() || countingDown() || recording()"
  type="button"
  aria-label="Open feedback panel"
  (click)="openPanel()"
>
  <span class="dot" aria-hidden="true"></span>
  <span class="icon" aria-hidden="true">
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  </span>
  <span>Give feedback</span>
</button>

<!-- Slide-out feedback panel -->
<aside class="panel" [class.is-open]="panelOpen()" aria-label="Feedback panel">
  <header class="panel-head">
    <div class="top">
      <div class="brand">
        <div class="logo"><img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAARMSURBVHhe7ZtLKDVhGMfHJZFcSxZusXAWNpKycU1yi51sKBLKQimULNxzWZDLAgtrUZSiJAs5ykIukaTjFrHQF/qQyHm+nikn8z7HcWbm/aY5zfzrtzr9533n9803l3eGIAiCTRCEPwYF9134KwgCGBTcd9EE+4NRwH03BZgCnPxgFEwBpgBTgCnAFGBYARaLRZ0Ab29vSE9Ph5KSEiguLlZFUVERpKamQlRUFPj7+5OxeFNQUAAXFxfqBOBEd3d3gVfe3t7g4eEBjo+PYXp6GsrLyyE4OJiMqxbc+aenJ7Db7eoFHBwcsPvBNSijoaEBfH19yfhKqKiogNfXV3HbXATwPAJcZXl5GaKjo8kc5IAi7Xa7Y5seJQCDRxueI9h5uEtbW5tke6oFBAQEgM1mk2z0f2d+fl48+bJzcRc8rzw+PorbUi0A/182NzfD6OgoDA0NiZP7/Pxk5yzJ90NQacrKyshc5JCRkQHn5+fqBbCkpaXBx8cHO19H5ubmID8/n1wCCwsLxZ0aHByEy8tLtkayurqq+qSYlJQEVquVr4CsrCyXArq6ukiHJS4uDtbW1tiqJHgWT0hIIF25BAYG8hWQnZ3tUkB/fz/pOAMl3N3dsXVJSktLSU8B+hSATExMsHVJ6uvrSUcB+hVQU1PD1iWpra0lHQXoV0BlZSVblwQFsR0F6FdAS0sLW5ckMzOTdBSgTwFeXl6wsbHB1h25vb2FiIgI0lOAPgVUV1ezVUmmpqZIRyHaCujs7CSd74SEhEBjYyM8Pz+zVUfwkTk5OZl0FaKtgJ2dHfG2eXx8nLC4uAhHR0dshaS9vZ2MqwJtBajN2NiYqgchJ3iGAFy9qaurI+NxwDME3N/fQ3d3N5f7fwbPEPAVvPxVVVWRcVXgWQK+gktb7NgK0VbA1taW+Ejc19dH6OnpERdV8Abot0WT9/d3yMnJIeMrQFsB7qwHIPiOAFeDXcVqtYKfnx/pykRbAe7eCSKJiYm/rgnk5eWRnkz0KwBpampiNyHJ5OQk6chE3wIsFov4puinbG9vg4+PD+nJQN8CcOdOTk7YzTiCK7uRkZGkJwN9C0AODw/ZzThyc3MDsbGxpCMDfQsIDQ2Fq6srdjOOXF9fQ0xMDOnJQN8C8B0CXvN/Cl4qg4KCSE8G+hawsLDAbkKSlZUV0pGJtgJ6e3tJ5yc6OjrYOklrayvpyURbASMjI+IhGx4eTggLCxNff+PHC7Ozs2yVBC+P8fHxZA4y0VYATvr09BTOzs4I+JYZz+ruZmBggIyvAG0F8Ao+B3D6dMbzBGxubqq99H3HcwS8vLyIhz2nf/kv+ArIzc1l5606eM4YHh6GlJQUMh4H+ArA7/xw6Xt/fx/29vZkgd//rK+vw9LSEszMzIhfnuD3Bng3yI7DEb4C8OEFL3NKwEOb85K3O/AV4IGYAkwBpgBTgCnAFODkB6MgCjD8H08b+s/n/wHWLIxBx0aEywAAAABJRU5ErkJggg==" alt="Brafton" /></div>
        <div>
          <h1>Feedback</h1>
          <!-- Reused @brafton/feedback-components status chip (with dropdown). -->
          <fb-status-chip [statuses]="pageStatuses" [current]="currentPageStatus()" (statusChange)="onPageStatusChange($event)"></fb-status-chip>
        </div>
      </div>

      <div class="head-actions">
        @if (!loggedIn()) {
          <a class="signin-btn" [href]="appBaseUrl" target="_blank" rel="noopener" (click)="onSignIn()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" /><polyline points="10 17 15 12 10 7" /><line x1="15" y1="12" x2="3" y2="12" /></svg>
            Sign in
          </a>
        }

        @if (loggedIn() && (currentMockupUrl() || availableMockups().length)) {
          <button class="icon-btn" type="button" [attr.aria-label]="currentMockupUrl() ? 'View assigned mockup' : 'Assign a mockup'" [title]="currentMockupUrl() ? 'View assigned mockup' : 'Assign a mockup'" (click)="openMockup()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" /><circle cx="8.5" cy="8.5" r="1.5" /><path d="m21 15-5-5L5 21" /></svg>
          </button>
        }

        <button
          class="icon-btn"
          type="button"
          [class.is-active]="markersHidden()"
          [attr.aria-label]="markersHidden() ? 'Show pins' : 'Hide pins'"
          [title]="markersHidden() ? 'Show pins on page' : 'Hide pins on page'"
          (click)="toggleMarkers()"
        >
          @if (markersHidden()) {
            <!-- eye-off: markers are hidden, click to show -->
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9.88 9.88a3 3 0 0 0 4.24 4.24" /><path d="M10.73 5.08A10.43 10.43 0 0 1 12 5c6.5 0 10 7 10 7a13.16 13.16 0 0 1-1.67 2.68" /><path d="M6.61 6.61A13.526 13.526 0 0 0 2 12s3.5 7 10 7a9.74 9.74 0 0 0 5.39-1.61" /><line x1="2" y1="2" x2="22" y2="22" /></svg>
          } @else {
            <!-- eye: markers are shown, click to hide -->
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" /><circle cx="12" cy="12" r="3" /></svg>
          }
        </button>

        <!-- AI ("Ask AI") robot button — hidden for now; widget has no AI features
             at this stage. Restore this block when AI is added back to the widget. -->
        <!-- @if (loggedIn()) {
          <button class="ai-btn" type="button" aria-label="Ask AI" title="Ask AI">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="8" width="16" height="12" rx="3" /><path d="M12 4v4" /><circle cx="12" cy="3.2" r="1" /><circle cx="9" cy="14" r="1.2" fill="currentColor" /><circle cx="15" cy="14" r="1.2" fill="currentColor" /><path d="M9.5 17.5h5" /></svg>
          </button>
        } -->

        <button class="icon-btn close-panel" type="button" aria-label="Close" (click)="closePanel()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12" /></svg>
        </button>
      </div>
    </div>

    <div class="panel-meta">
      @if (loggedIn()) {
        <div class="stat"><b>{{ roundFeedbackTotal() }}</b><span>Pins</span></div>
        <div class="stat"><b>{{ viewingCount() }}</b><span>Viewing</span></div>
      }
      <div class="stat"><b>{{ openCount() }}</b><span>Open</span></div>
      <div class="stat"><b>{{ resolvedCount() }}</b><span>Resolved</span></div>
    </div>
  </header>

  <!--
    Panel toolbar ("subheading"): the Add-feedback action, a viewport
    (screen-size) segmented control, and the "All status" filter dropdown.
    Markup + styling only — no behaviour is wired yet.
  -->
  <div class="toolbar">
    <button class="btn primary" type="button" aria-label="New item" (click)="onAddFeedback()">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12 5v14M5 12h14" />
      </svg>
      <span class="add-label">New Item</span>
    </button>

    <!--
      Filters live in one group so they wrap together: at this panel width they drop
      below the primary action as a set, rather than leaving a lone control stranded
      on its own row.
    -->
    <div class="toolbar-filters">
      <!--
        Viewport filter, collapsed to a single control: the trigger shows the current
        choice (or "all sizes"), and hovering or focusing reveals the sizes. The reveal
        is absolutely positioned so it cannot reflow the toolbar.
      -->
      <div class="screen-filter" role="group" aria-label="Viewport">
        <button
          class="f-trigger screen-trigger"
          type="button"
          [class.has-value]="!!screenFilter()"
          [title]="screenFilterTitle()"
          [attr.aria-label]="screenFilterTitle()"
        >
          @switch (screenFilter()) {
            @case ('desktop') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="4" width="20" height="13" rx="2" /><path d="M8 21h8M12 17v4" /></svg>
            }
            @case ('tablet') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="2" width="14" height="20" rx="2" /><path d="M11 18h2" /></svg>
            }
            @case ('mobile') {
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="7" y="2" width="10" height="20" rx="2" /><path d="M11 18h2" /></svg>
            }
            @default {
              <!-- "all sizes": the three viewports stacked -->
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="5" width="13" height="9" rx="1.5" /><rect x="16" y="8" width="6" height="11" rx="1.5" /><path d="M6 18h5" /></svg>
            }
          }
        </button>

        <div class="screen-options">
          <div class="seg" role="listbox">
            <button
              type="button"
              [class.is-active]="!screenFilter()"
              aria-label="All sizes"
              title="All sizes"
              (click)="clearScreenFilter()"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="5" width="13" height="9" rx="1.5" /><rect x="16" y="8" width="6" height="11" rx="1.5" /><path d="M6 18h5" /></svg>
            </button>
            <button
              type="button"
              [class.is-active]="screenFilter() === 'desktop'"
              aria-label="Desktop"
              title="Desktop"
              (click)="toggleScreen('desktop')"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="4" width="20" height="13" rx="2" />
                <path d="M8 21h8M12 17v4" />
              </svg>
            </button>
            <button
              type="button"
              [class.is-active]="screenFilter() === 'tablet'"
              aria-label="Tablet"
              title="Tablet"
              (click)="toggleScreen('tablet')"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="5" y="2" width="14" height="20" rx="2" />
                <path d="M11 18h2" />
              </svg>
            </button>
            <button
              type="button"
              [class.is-active]="screenFilter() === 'mobile'"
              aria-label="Mobile"
              title="Mobile"
              (click)="toggleScreen('mobile')"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="7" y="2" width="10" height="20" rx="2" />
                <path d="M11 18h2" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      <!-- AI feedback toggle: user feedback only until this is switched on -->
      @if (aiFeedbackCount() > 0) {
        <button
          class="f-trigger ai-toggle"
          type="button"
          [class.has-value]="showAiFeedback()"
          [attr.aria-pressed]="showAiFeedback()"
          [title]="
            showAiFeedback()
              ? 'Hide AI feedback'
              : 'Show ' + aiFeedbackCount() + ' AI feedback item' + (aiFeedbackCount() === 1 ? '' : 's')
          "
          (click)="toggleAiFeedback()"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="4" y="8" width="16" height="12" rx="2" />
            <path d="M12 4v4M9 2h6" />
            <circle cx="9" cy="14" r="1" />
            <circle cx="15" cy="14" r="1" />
          </svg>
          <span class="f-label">AI</span>
        </button>
      }

      <!-- "All status" filter dropdown -->
      <div class="f-drop">
        <button
          class="f-trigger"
          type="button"
          aria-haspopup="listbox"
          [class.has-value]="statusFilter().size > 0"
          [attr.aria-expanded]="filterMenuOpen()"
          (click)="toggleFilterMenu()"
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" /></svg>
          <span class="f-label">{{ statusFilterLabel() }}</span>
          @if (statusFilter().size > 1) {
            <span class="f-count">{{ statusFilter().size }}</span>
          }
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9" /></svg>
        </button>

        <div class="f-menu" [class.is-open]="filterMenuOpen()" role="listbox">
          <div class="f-actions">
            <button type="button" (click)="selectAllStatuses()">Select all</button>
            <button type="button" (click)="clearStatuses()">Clear</button>
          </div>
          <div class="f-divider"></div>
          @for (option of statusFilterOptions; track option.value) {
            <div
              class="f-opt"
              role="option"
              [class.cur]="isStatusSelected(option.value)"
              [attr.aria-selected]="isStatusSelected(option.value)"
              (click)="toggleStatus(option.value)"
            >
              <span class="f-check">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
              </span>
              <span class="f-label">{{ option.label }}</span>
              <span class="f-count">{{ statusCounts()[option.value] || 0 }}</span>
            </div>
          }
        </div>
      </div>
    </div>
  </div>

  @if (missingConfig) {
    <div class="panel-status is-error" role="status">
      No org or project are currently set. Please visit the
      <a [href]="appBaseUrl" target="_blank" rel="noopener">feedback app</a>
      to set up a feedback round.
    </div>
  } @else {
    @if (statusKind === 'error' && statusMessage) {
      <div class="panel-status is-error" role="status">{{ statusMessage }}</div>
    }
    <!-- Feedback for the current page (read-only list + pager). -->
    <app-feedback-list
      [items]="feedbackItems()"
      [page]="feedbackPage()"
      [perPage]="feedbackPerPage"
      [total]="feedbackTotal()"
      [lastPage]="feedbackLastPage()"
      [unreadCounts]="unreadCounts()"
      (pageChange)="onFeedbackPageChange($event)"
      (statusChange)="onFeedbackStatusChange($event)"
      (openFeedback)="onFeedbackOpen($event)"
    />
  }
  <div class="panel-version">v{{ widgetVersion }}</div>
</aside>

<!-- Delayed-capture countdown: top-left, non-interactive, gone before the grab -->
@if (countdownValue() !== null) {
  <div class="capture-countdown" aria-hidden="true">{{ countdownValue() }}</div>
}

<!-- Recording controls: a Stop button + remaining seconds, top-left of the screen -->
@if (recording()) {
  <div class="capture-recording">
    <button class="rec-stop" type="button" aria-label="Stop recording" (click)="stopVideoCapture()">
      <span class="rec-square" aria-hidden="true"></span>
    </button>
    <span class="rec-count">{{ videoCountdown() }}s</span>
  </div>
}

<!-- Pin-placement overlay (crosshair layer + cursor hint) -->
<app-placement-overlay [active]="placing()" (place)="onPlace($event)" />

<!-- Collect the reporter's name + email (once, then stored) -->
<app-identity-modal
  [open]="identityModalOpen()"
  (save)="onIdentitySave($event)"
  (cancel)="onIdentityCancel()"
/>

<!-- Choose when to capture the screenshot for the new pin -->
<app-capture-screenshot
  [open]="captureModalOpen()"
  [markerNumber]="captureMarkerNumber()"
  [nativeCaptureAvailable]="nativeCaptureAvailable"
  (captureNow)="onCaptureNow()"
  (captureDelay)="onCaptureDelay()"
  (captureVideo)="onCaptureVideo()"
  (uploadScreenshot)="onCaptureUpload()"
  (skipCapture)="onCaptureSkip()"
  (cancel)="onCaptureCancel()"
/>

<!-- New-feedback draft popover (opens beside the marker after capture) -->
<app-new-feedback
  [open]="newFeedbackOpen()"
  [markerNumber]="captureMarkerNumber()"
  [screenshotUrl]="screenshotUrl()"
  [videoUrl]="videoUrl()"
  [reporter]="reporterIdentity()"
  [submitting]="submitting()"
  [captureWarning]="captureWarning()"
  [screenshotSkipped]="screenshotSkipped()"
  [anchorX]="markerAnchorX()"
  [anchorY]="markerAnchorY()"
  (submit)="onNewFeedbackSubmit($event)"
  (cancel)="onNewFeedbackCancel()"
/>

<!-- Assigned-mockup lightbox for the current page -->
<app-mockup-viewer
  [open]="mockupOpen()"
  [mockupUrl]="currentMockupUrl()"
  [pageLabel]="mockupPageLabel"
  [availableMockups]="availableMockups()"
  [assigning]="assigningMockup()"
  (mockupSelect)="onMockupSelect($event)"
  (close)="closeMockup()"
/>

<!-- Feedback detail popover (positioned beside the marker) -->
<app-feedback-detail
  [open]="!!selectedFeedback()"
  [feedback]="selectedFeedback()"
  [anchor]="detailAnchor()"
  [appBaseUrl]="appBaseUrl"
  [feedbackRoundId]="feedbackRoundId ?? ''"
  [loggedIn]="loggedIn()"
  [comments]="commentThread()"
  [commentsLoading]="commentsLoading()"
  [commentPosting]="commentPosting()"
  (close)="onFeedbackDetailClose()"
  (statusChange)="onFeedbackStatusChange($event)"
  (commentPost)="onPostComment($event)"
/>

<!-- Asks why an item is being disregarded before its status changes -->
<fb-disregard-reason
  [open]="disregardPending() !== null"
  [itemLabel]="disregardPending()?.element"
  (confirm)="onDisregardConfirmed($event)"
  (cancel)="onDisregardCancelled()"
/>

</div>
